import { FC } from 'react';

import SunshineCard from 'components/_core/SunshineCard';
import { TeamMember } from 'features/Team/hooks/useTeamMembers';

import { isFreeMember } from '../../../../utils';
import MemberListItem from './components/TeamMemberListItem';

interface TeamMembersListProps {
  canUnlockMembers: boolean;
  hasInvitationsLeft: boolean;
  onInvitationQuotaError: () => void;
  onUnlockUser: () => void;
  isFreeRolesOnly: boolean;
  teamMembers: TeamMember[];
}

const TeamMembersList: FC<TeamMembersListProps> = ({
  canUnlockMembers,
  hasInvitationsLeft,
  isFreeRolesOnly,
  onInvitationQuotaError,
  onUnlockUser,
  teamMembers,
}) => (
  <SunshineCard.Group>
    {teamMembers.map((member) => (
      <MemberListItem
        canUnlockMember={isFreeMember(member) || canUnlockMembers}
        hasInvitationsLeft={hasInvitationsLeft}
        isFreeRolesOnly={isFreeRolesOnly}
        key={member.companyUserOrInvitationId}
        onInvitationQuotaError={onInvitationQuotaError}
        onUnlockUser={onUnlockUser}
        teamMember={member}
      />
    ))}
  </SunshineCard.Group>
);

export default TeamMembersList;
